<template>
  <basic-container>
    <div class="adjustment-detail-container">
      <div class="inner-con">
        <div class="project-title">{{ basicInfoData.name }}

          <span class="serial_number" 
          v-if="basicInfoData.newAdjustId"
          @click="toAdjust(basicInfoData.newAdjustId)"
            >调整后尽调</span
          >
        </div>
        <div class="project-status">
          <div class="status-title">审批状态</div>
          <div
            class="status-content"
            :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]"
          >
            {{ basicInfoData.auditStatusStr }}
          </div>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane label="项目详情" name="first">
            <InfoContainer
              style="margin-top: 20px"
              :infoTitle="InfoContainerConfig['infoTitle']"
              :contentConfig="InfoContainerConfig['infoContent']"
              class="info_container"
            >
              <template slot="basicInfo">
                <avue-form
                  ref="basicInfo"
                  v-model="basicInfoData"
                  :option="formConfig"
                >
                  <template #name>
                    <!-- 存在绑定ID时不可更改项目 -->
                    <!-- <CommonSelect
                      :clearable="false"
                      bindLabel="name"
                      bindKey="id"
                      bindValue="name"
                      dataUrl="bl/blreportstandard/page"
                      methods="get"
                      dataMethod="params"
                      searchKey="name"
                     
                      :disabled="!isEditable"
                      :bindId="
                        basicInfoData.id ? basicInfoData.id : ''
                      "
                      @handleChange="setProjectInfo"
                    /> -->

                    <div class="project-name" @click="goProject">
                      {{ basicInfoData.name }}
                    </div>
                  </template>
                </avue-form>
              </template>
            </InfoContainer>

    

            <Accessory
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
              :idname="uploadPermissionNameTwo"
              :fileMenuUrlname="uploadPermissionNameOne"
              :projectid="id"
              :upload="true"
              :permissionList="permissionList"
              :isPermission="true"
            />

            
            <AuditInfo
              ref="auditInfo"
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="isStartedProcess && auditFormData && auditFormData != {}"
              :formDetailData="auditFormData"
              :isEditable="
                processDetail.process ? processDetail.process.isEditable : false
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />
            <CommentStep
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="commentList.length > 0"
              :commentList="commentList"
              :taskSaveData="taskSaveData"
              :taskNo="
                processDetail.process ? Number(processDetail.process.taskNo) : 0
              "
              :status="
                processDetail.process && processDetail.process.status
                  ? processDetail.process.status
                  : 'done'
              "
            />

            <CommentTable
              v-loading="!dataReady"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(153, 153, 153, 0.8)"
              v-if="flowData.length > 0"
              :flowData="flowData"
            />

            <!-- 会签意见区 -->
            <InfoContainer
              v-if="!isStartedProcess"
              class="comment-container"
              style="margin-top: 20px"
              :infoTitle="commentBlockConfig['infoTitle']"
              :contentConfig="commentBlockConfig['infoContent']"
            >
              <template #comment>
                <CommentBlock
                  ref="commentBlock"
                  @fileChange="fileChange"
                  :id="id"
                />
              </template>
            </InfoContainer>
          </el-tab-pane>

          <el-tab-pane label="流程图" name="second">
            <template v-if="activeName == 'second'">
              <el-card shadow="never" style="margin-top: 5px">
                <wf-design
                  ref="bpmn"
                  style="height: 500px"
                  :options="bpmnOption"
                ></wf-design>
              </el-card>
            </template>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 1.流程状态为todo时 2.提交状态为未提交可编辑时显示底部操作按钮-->
    <BottomLine
      ref="bottomLine"
      :auditState="basicInfoData.auditStatus"
      :processDetail="processDetail"
      :isStartedProcess="isStartedProcess"
      :goEdit="!isStartedProcess||(workFlowState && workFlowState.isFirstFlowPermission&&isStartedProcess)"
      @goEdit="goEdit"
      @buildNewOne="buildNewOne"
      @startProcess="startProcess()"
      @saveTask="saveTask"
      @flowNext="flowNext"
      @openPrintForm="goPrint"
      @refreshData="refreshData"
    />
  </basic-container>
</template>
<script>
import {
  queryAdjustmentNum,
  adjustmentDetail,
  addAdjustment,
  getPocessName,
} from "@/api/factoring/factoring";
import InfoContainer from "@/components/infoContainer/infoContainer";
import { addAdjustmentConfig } from "./adjustmentConfig.js";
import { mapGetters } from "vuex";

// 工作流相关组件
import Accessory from "@/components/accessoriesother/accessory";
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo";
import CommonSelect from "@/components/commonSelect/commonSelect";
import CommentStep from "@/components/workflowComponents/commentStep/commentStep";
import CommentTable from "@/components/workflowComponents/commentTable/commentTable";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine";
import workFlow from "@/mixins/workFlow";

export default {
  name: "AdjustmentDetail",
  mixins: [workFlow],
  data() {
    return {
      id: "",
      isStartedProcess: false,
      processKey: "process_projectAdjustment",
      detailFormUrl: '/factoring/projectAdjustment/adjustmentDetail',   
      activeName: "first",
      basicInfoData: {},
      formConfig: addAdjustmentConfig(),
      InfoContainerConfig: {
        infoTitle: "基本信息",
        infoContent: [
          {
            title: "项目初步方案",
            prop: "basicInfo",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["workFlowData", "workFlowState", "userInfo"]),
  },
  components: {
    InfoContainer,
    Accessory,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock,
  },
  watch: {
    "$route.prams.id": {
      handler(val) {
        this.id = val;
        this.queryAdjustmentDetail(this.id);
      },
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.queryAdjustmentDetail(this.id);
  },
  methods: {
    goProject() {
      this.$router.push({
        path: `/factoring/projectManage/projectDetail/${this.basicInfoData.projectInfoId}`,
      });
    },

    toAdjust(id) {
       this.$router.push({
          path: `/factoring/projectAdjustment/adjustmentDetail/${id}`,
        });
    },
    goEdit() {
      if (
        this.basicInfoData.createUser == this.userInfo.user_id ||
        this.basicInfoData.assistUser == this.userInfo.user_id
      ) {
        this.$router.push({
          path: `/factoring/projectAdjustment/editAdjustment/${this.id}`,
        });
      } else {
        this.$message.warning("您暂无权限对本条数据进行编辑");
      }
    },
    // 设置选择的项目
    async setProjectInfo(data) {
   
      if (data) {
        this.basicInfoData.name = data.name;
        this.basicInfoData.auditName = data.name;
        this.basicInfoData.number = data.number;
        // 赋值项目相关数据
        this.basicInfoData.projectInfoId = data.projectInfoId;

        this.basicInfoData.reportId = data.id;

        this.basicInfoData.sellerCustId = data.sellerCustId;
        this.basicInfoData.sellerCustName = data.sellerCustName;
        this.basicInfoData.buyerCustName = data.buyerCustName;
        this.basicInfoData.projectType = `${data.projectType}`;
        this.basicInfoData.projectComeFrom = `${data.projectComeFrom}`;
        this.basicInfoData.factoringCredit = data.factoringCredit;
        this.basicInfoData.projectTypeStr = data.projectTypeStr;
        this.basicInfoData.accountingEntity = data.accountingEntity;

        // 设置协办数据
        this.basicInfoData.assistUserName = data.assistUserName;
        this.basicInfoData.assistUser = data.assistUser;

        // 查询调整申请次数
        let adjustmentRes = await queryAdjustmentNum({
          projectInfoId: data.projectInfoId,
        });
        this.basicInfoData.adjustNumber = adjustmentRes.data.data;
      }
    },
    async queryAdjustmentDetail(id) {
      let res = await adjustmentDetail({ id: id });
      if (res.data.code == 200) {
        this.basicInfoData = res.data.data;
      }

      // 查询流程数据
      if (res.data.data && res.data.data.flowableId) {
        this.isStartedProcess = true;
        // 集成在workFlow.js中
        await this.queryFlowData(res.data.data.flowableId);
      } else {
        // 未启动流程 查询第一个节点的文件上传权限
        this.processDefinedId = await this.userQueryProcessDefinedId(
          this.processKey
        );
        this.permissionList = await this.queryTaskUploadDetail(
          this.processDefinedId,
          "",
          true
        );
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId);
      }
      // 判断页面是否可编辑（1.流程未提交 2.流程详情中isEditable为true可编辑）
      let presentFlow = this.flowData[this.flowData.length - 1];
      if (
        this.basicInfoData.auditStatus == 0 ||
        this.processDetail.flow[2].historyActivityId ==
          presentFlow.historyActivityId
      ) {
        this.columnEditChange(true);
      } else {
        this.columnEditChange(false);
      }
    },

    refreshData() {
      this.queryAdjustmentDetail(this.id);
    },

    columnEditChange(edit) {
      this.isEditable = edit;
      this.formConfig.column.map((item) => {
        // if(item.prop == 'sellerCustId') {
        //     return
        // }
        if (!item.alwaysDisabled) {
          if (item.prop == "name") {
            item.disabled = !edit;
            item.formslot = true;
          } else {
            item.disabled = !edit;
            item.formslot = false;
          }
        }
      });
    },

    fileChange(fileList) {
      let self = this;
      if (fileList.length > 0) {
        this.attchmentList = [];
        fileList.map((item) => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link,
          });
        });
      }
    },

    async startProcess() {
      let redirectInfo = {
        url: this.detailFormUrl,
        id: this.id,
      };
      // let processNameRes = await getPocessName(this.basicInfoData);
      let params = {
        detailFormUrl: JSON.stringify(redirectInfo),
        processId: this.processDefinedId,
        comment: this.$refs.commentBlock.$data.opinionContent,
        attachmentList: this.attchmentList,
        // processInstanceName: processNameRes.data.data.processInstanceName,
      };
      let processInsId = await this.startWorkFlowProcess(params);
      this.basicInfoData.flowableId = processInsId;
      this.saveProject();
    },

    // 流程流转
    async flowNext(taskInfoList) {

      let passType = await this.validForm();

      if (!passType) {
        return;
      }

      let presentFlow = this.flowData[this.flowData.length - 1];
      if (
        this.processDetail.flow[2].historyActivityId ==
        presentFlow.historyActivityId
      ) {
        this.submitForm();
      }

      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      let taskName = this.processDetail.process.taskName;

      // 流程表单数据
      let valid = this.$refs.auditInfo.validData();
      if (valid) {
        let customData = this.$refs.auditInfo.commentDetail;
        let formData = this.$refs.auditInfo.$data.formData;

        let variables = this.dealAuditForm(formData, customData);
        if (taskInfoList) {
          await this.selectPeopleFlowNext(
            taskId,
            taskName,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables,
            JSON.stringify(taskInfoList)
          );
        } else {
          await this.taskFlowNext(
            taskId,
            processInsId,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables
          );
        }

        // 刷新数据
        this.queryAdjustmentDetail(this.id);
        this.$forceUpdate();
      }
    },
    validForm() {
      let self = this;
      return new Promise((resolve, reject) => {
        this.$refs.basicInfo.validate((valid, done) => {
                if (valid) {
                    done();
                    resolve(true);
                 
                }else {
                    self.$message({
                        type: "warning",
                        message: "请补全表单后提交",
                    });
                    }
                
            })
       
      });
    },
    saveProject() {
      let self = this;
      // 验证数据是否完全
      this.$refs.basicInfo.validate((valid, done) => {
        if (valid) {
          // 校验通过, 提交数据
          self.submitForm();
          done();
        }
      });
    },

    async submitForm() {
      let params = {
        ...this.basicInfoData,
      };
      params.id = this.id;
      let res = await addAdjustment(params);
      if (res.data.code == 200) {
        // 刷新界面
        this.queryAdjustmentDetail(this.id);
        this.$message({
          message: "修改成功",
          type: "success",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.adjustment-detail-container {
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  .inner-con {
    width: 1000px;
    margin: 0 auto;
    margin-top: 3px;
    .project-name {
      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      color: #409eff;
    }
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }
    .project-title {
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .project-status {
      .status-title {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content {
        text-align: right;
        font-family: "微软雅黑", sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
    }
  }
  .comment-container {
    margin-top: 20px;
    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }
  .stateTopdiv::before {
    content: "";
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 5px;
  }
  .color_0::before {
    background: #fec03d;
  }
  .color_1::before {
    background: #409eff;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #f56c6c;
  }
  .color_4::before {
    background: #f56c6c;
  }
}
/deep/.el-tabs__item {
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
/deep/.el-tabs__item.is-active {
  background: none;
}
/deep/.el-tabs__header {
  margin: 0px;
}

.detail-content {
  /deep/.detail-one {
    padding-top: 0 !important;
  }
}
.serial_number {
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
}
</style>